/** Addendum markdown to render, or null when it is blank. */
export const visibleCrewAddendum = (
  markdown: string | null | undefined,
): string | null => {
  const visible = markdown?.trim() ?? ''
  return visible.length > 0 ? visible : null
}
